import { render, staticRenderFns } from "./Management.vue?vue&type=template&id=40c722a0&scoped=true&"
import script from "./Management.vue?vue&type=script&lang=js&"
export * from "./Management.vue?vue&type=script&lang=js&"
import style0 from "./Management.vue?vue&type=style&index=0&id=40c722a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c722a0",
  null
  
)

export default component.exports